import React from 'react';
import { handleEnterPress } from '../helpers/util';
import styles from '../styles/listSelect.scss';
const ListSelect = ({ items = [], itemSelected, icon: Icon, }) => {
    return (React.createElement("ul", { className: styles.list }, items.map((x, i) => {
        const { title, text, value } = x;
        let icon;
        if (x.icon) {
            icon = React.createElement("div", { className: styles.icon }, x.icon);
        }
        else if (Icon) {
            icon = (React.createElement("div", { className: styles.icon },
                React.createElement(Icon, null)));
        }
        else {
            icon = '';
        }
        const onClick = () => itemSelected(value);
        return (React.createElement("li", { key: i, className: styles.item, onClick: onClick, onKeyDown: handleEnterPress(onClick), 
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
            role: 'button', tabIndex: 0 },
            icon,
            React.createElement("div", { className: styles.text_container },
                React.createElement("span", { className: styles.title }, title),
                React.createElement("span", { className: styles.text }, text))));
    })));
};
export default ListSelect;
